<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_APPLICATION_ID')"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-select-popup
            ref="selectPopupapplicationId"
            v-model="objMobileAppMgt.applicationId"
            pageId="PGE_CMP_00028"
            @select="onSelectApplicationId"
          />
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_APPLICATION_NM')"
          />          
        </div>
        <div class="col-xs-5 ">
          {{ objMobileAppMgt.applicationName }}
        </div>        
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_PORTL')"
          />
        </div>
        <div class="col-xs-5 ">
          {{ objMobileAppMgt.portalId }}
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_DVC_TYPE')"
          />
        </div>
        <div class="col-xs-5 ">
          {{ objMobileAppMgt.deviceTypeName }}
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_MBL_APP_CNTN_MLNG_ID')"
          />
        </div>
        <div class="col-xs-5 ">
          <cmp-mlng-editor
            ref="mlngEditor"
            :pageId="contextPageId"
            :multiLanguageId="objMobileAppMgt.mobileApplicationContentMultiLanguageId"
          />
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_BSIC_ISTL_YN')"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-radio
            v-model="objMobileAppMgt.basicsInstallationYn"
            value="Y"
          >
            {{ 'Yes' }}
          </sui-radio>
          <sui-radio
            v-model="objMobileAppMgt.basicsInstallationYn"
            value="N"
          >
            {{ 'No' }}
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div
          class="col-xs-1"
          style="height:39px;"
        >
          <sui-input-label
            :label="$t('MSG_TXT_ICON_IMG_SM')"
          />
        </div>
        <div class="col-xs-5">
          <cmp-single-thumbnail-viewer
            ref="thumbnailViewer"
            :pageId="contextPageId"
            :fileUid="objMobileAppMgt.imageFilePath1"
          />
          <sui-file-uploader
            :btnClass="'btn_innerTbl_border'"
            @change="uploadSmallImage"
          />
          <div>
            <sui-button
              type="button"
              :class="'btn_innerTbl_border'"
              @click="onClickDeleteSmallImage"
            >
              {{ $t("MSG_BTN_DEL") }}
            </sui-button>
          </div>
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ICON_IMG_LG')"
          />
        </div>
        <div class="col-xs-5">
          <cmp-single-thumbnail-viewer
            ref="thumbnailViewer2"
            :pageId="contextPageId"
            :fileUid="objMobileAppMgt.imageFilePath2"
          />
          <sui-file-uploader
            :btnClass="'btn_innerTbl_border'"
            @change="uploadLargeImage"
          />
          <div>
            <sui-button
              type="button"
              :class="'btn_innerTbl_border'"
              @click="onClickDeleteLargeImage"
            >
              {{ $t("MSG_BTN_DEL") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_USR')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <cmp-user-name-link
            :pageId="contextPageId"
            :displayType="'1'"
            :displayLanguageId="objMobileAppMgt.firstRegistrationDisplayLanguageId"
            :userId="objMobileAppMgt.firstRegistrationUserId"
            :loginId="objMobileAppMgt.firstRegistrationLoginId"
            :userName="objMobileAppMgt.firstRegistrationUserName"
            :userGlobalName="objMobileAppMgt.firstRegistrationUserGlobalName"
            :departmentName="objMobileAppMgt.firstRegistrationDepartmentName"
            :departmentEnglishName="objMobileAppMgt.firstRegistrationDepartmentEnglishName"
            type="link"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          {{ objMobileAppMgt.firstRegistrationDTM }}
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <cmp-user-name-link
            :pageId="contextPageId"
            :displayType="'1'"
            :displayLanguageId="objMobileAppMgt.finalModificationDisplayLanguageId"
            :userId="objMobileAppMgt.finalModificationUserId"
            :loginId="objMobileAppMgt.finalModificationLoginId"
            :userName="objMobileAppMgt.finalModificationUserName"
            :userGlobalName="objMobileAppMgt.finalModificationUserGlobalName"
            :departmentName="objMobileAppMgt.finalModificationDepartmentName"
            :departmentEnglishName="objMobileAppMgt.finalModificationDepartmentEnglishName"
            type="link"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          {{ objMobileAppMgt.finalModificationDTM }}          
        </div>
      </div>
    </div>    
    <div class="mrB30" />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="contextPageId"
        type="button"
        class="comm_btn_border"
        :disabled="!isDeleted"
        @click="onClickRestore"
      >
        {{ $t("MSG_BTN_RESTORE") }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t("MSG_BTN_NEW") }}
      </sui-button>
      <sui-button
        v-show="!isDeleted"
        v-permission:delete="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t("MSG_BTN_DEL") }}
      </sui-button>
      <sui-button
        v-show="isDeleted"
        v-permission:delete="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDiscard"
      >
        {{ $t("MSG_BTN_DSCD") }}
      </sui-button>
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>  
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];

export default {
  name: 'PGE_CMP_00026_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    selectedGridRowData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isNew : true,
      isDeleted: false,
      objMobileAppMgt: {
        portalId: '',
        basicsInstallationYn: 'Y',
        deleteYn: '',
        firstRegistrationUserId: '',
        searchCondition: '',
        arrayalOrder: '',
        mobileApplicationContentMultiLanguageId: '',
        imageFilePath1: '',
        imageFilePath2: '',
        firstRegistrationDTM: '',
        finalModificationDTM: '',
        finalModificationUserId: '',
        applicationId: '',
        applicationName: '',
        deviceTypeValue: '',
        deviceTypeName: '',
      },
      imgList: [],
      attachRestrictionSize: 1000,
    };
  },
  computed: {},
  watch: {
    selectedGridRowData(selectObj) {
      if (selectObj) {
        this.loadMobileAppMgt();
      } else {
        this.onClickNew();
      }
    },
  },
  created() {
    this.customOptions = {
    };
  },  
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadMobileAppMgt() {
      if(this.selectedGridRowData) {
        const applicationId = this.selectedGridRowData.applicationId;
        const portalId = this.selectedGridRowData.portalId;
        const deleteYn = this.selectedGridRowData.deleteYn;
        if(!utils.isEmpty(applicationId)) {          
          http.request(this.contextPageId, 'DTS_CMP_00117', {  
            path: {
              'application-id': applicationId,
            },
            query: {
              portalId: portalId,
              deleteYn: deleteYn,
            },
          }).then(res => {
            this.objMobileAppMgt = res.data;
            this.objMobileAppMgt.firstRegistrationDTM = utils.dateformatToClient(this.objMobileAppMgt.firstRegistrationDTM);
            this.objMobileAppMgt.finalModificationDTM = utils.dateformatToClient(this.objMobileAppMgt.finalModificationDTM);
            this.$refs.selectPopupapplicationId.setData({
              id: this.objMobileAppMgt.applicationId,
              text: this.objMobileAppMgt.applicationId,
            });            
            this.isNew = false;
            this.isDeleted = this.objMobileAppMgt.deleteYn === 'Y';
          });
        }
      }
    },  
    onClickNew() {
      this.$refs.mlngEditor.reset();
      utils.forEach(this.objMobileAppMgt, (value, key) => {
        this.objMobileAppMgt[key] = '';
      });
      this.objMobileAppMgt.basicsInstallationYn = 'Y';
      this.isNew = true;
      this.isDeleted = false;
      this.$emit('onClickSearch');
    },
    onClickDelete() {
      const portalId = this.objMobileAppMgt.portalId;
      const applicationId = this.objMobileAppMgt.applicationId;    
      if(!utils.isEmpty(applicationId)) {
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
          http.request(this.contextPageId, 'DTS_CMP_00120', {
            path: {
              'application-id': applicationId,
            },
            query: {
              portalId: portalId,
            }
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
            this.$emit('onClickSearch');
            this.onClickNew();
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickRestore() {
      const portalId = this.objMobileAppMgt.portalId;
      const applicationId = this.objMobileAppMgt.applicationId;    
      if(!utils.isEmpty(applicationId)) {
        utils.messageBox('confirm', this.$t('MSG_ALT_IS_RESTORE_DATA'), null, () => {
          http.request(this.contextPageId, 'DTS_CMP_00121', {
            path: {
              'application-id': applicationId,
            },
            query: {
              portalId: portalId,
            }
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_RESTORE_DATA'));
            this.$emit('onClickSearch');
            this.onClickNew();
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickDiscard() {
      const portalId = this.objMobileAppMgt.portalId;
      const applicationId = this.objMobileAppMgt.applicationId;    
      if(!utils.isEmpty(applicationId)) {
        utils.messageBox('confirm', this.$t('MSG_ALT_IS_DSCD_DATA'), null, () => {
          http.request(this.contextPageId, 'DTS_CMP_00122', {
            path: {
              'application-id': applicationId,
            },
            query: {
              portalId: portalId,
            }
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_DSCD_DATA'));
            this.$emit('onClickSearch');
            this.onClickNew();
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    validateData(selected) {
      return new Promise(resolve => {
        http.request(this.contextPageId, 'DTS_CMP_00124', {
          query: {
            portalId: selected.portalId,
            applicationId: selected.applicationId,
          },
        }).then(res => {
          resolve(res.data.resultCode);
        }).catch(() => {
          resolve(false);
        });
      });
    },
    onClickSave() {
      if (utils.isEmpty(this.objMobileAppMgt.applicationId)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_APPLICATION_ID')), null, () => {
        });
        return false;
      }

      const multiLanguageList = this.$refs.mlngEditor.getMlngEditingInfoFillEmptyWithGlobal();
      this.objMobileAppMgt.multiLanguageList = multiLanguageList;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        const dataServiceId = this.isNew ? 'DTS_CMP_00118' : 'DTS_CMP_00119';
        http.request(this.contextPageId, dataServiceId, {
          data: this.objMobileAppMgt,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('onClickSearch');
          this.onClickNew();
        });
      });
    },
    async onSelectApplicationId(selected) {
      if(utils.isEmpty(selected)) {
        return false;
      }
      const result = await this.validateData(selected);
      if(result === '0') {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ALREADY_RGST'), this.$t('MSG_TXT_APPLICATION_ID')), null, () => { // 메시지 수정
        });
        return false;
      }
      this.objMobileAppMgt.applicationId = selected.applicationId;
      this.$refs.selectPopupapplicationId.setData({
        id: selected.applicationId,
        text: selected.applicationId,
      });
      this.objMobileAppMgt.applicationName = selected.applicationName;
      this.objMobileAppMgt.portalId = selected.portalId;
      this.objMobileAppMgt.deviceTypeValue = selected.deviceTypeValue;
      this.objMobileAppMgt.deviceTypeName = selected.deviceTypeName;
    },
    uploadSmallImage(file) {
      if(utils.isEmpty(file)) return;

      const formData = new FormData();
      formData.append('file', file[0]);
      http.request(this.contextPageId, 'DTS_CMZ_00040', {
        path: {
          'target-path': 'storage',
        },
        data: formData,
      }).then(res => {
        this.objMobileAppMgt.imageFilePath1 = res.data.serverFileName;
      });
    },
    uploadLargeImage(file) {
      if(utils.isEmpty(file)) return;

      const formData = new FormData();
      formData.append('file', file[0]);
      http.request(this.contextPageId, 'DTS_CMZ_00040', {
        path: {
          'target-path': 'storage',
        },
        data: formData,
      }).then(res => {
        this.objMobileAppMgt.imageFilePath2 = res.data.serverFileName;
      });
    },
    onClickDeleteSmallImage() {
      this.objMobileAppMgt.imageFilePath1 = '';
    },
    onClickDeleteLargeImage() {
      this.objMobileAppMgt.imageFilePath2 = '';
    },
  },
};
</script>

<style scoped>
</style>
